import React from 'react'
import { renderDateTime } from '../../../helpers/HelperMethods';


class LogRow extends React.Component
{
    render() {
        let changeLog = [];

        if (this.props.changeLog) {
           changeLog = (this.props.changeLog.startsWith("Request for") ? this.props.changeLog.replace(/Request for (Site|Flow|PowerApp|PowerApp Solution|Power App Environment) change./, '$&,').split(',') : [this.props.changeLog]);
        }

        if (changeLog.length > 1) {
            const [a, ...b] = changeLog;
            changeLog = [...a.replace(/: /, '$&##').split('##'), ...b];
        }

        return(
            <div style={this.props.even? highlighted : normal}>
                 <div style={{fontSize: '12px'}} > 
                    <span style={dateStyle}>{renderDateTime(this.props.changeDate)} </span> 
                    {   
                        this.props.user && 
                        <span><span style={{color: '#0078D4'}}>{this.props.user.email}</span>: </span>
                    }
                    <span>
                        {   
                            changeLog.map((x, index) => 
                                <span key={index}>{x}<br/></span>
                            )
                        }
                    </span> 
                </div>
            </div>
        );
    }
}
export default LogRow

const highlighted = {
    textAlign:'left',
    padding:'8px',
    backgroundColor: 'rgb(205, 230, 247)'
}

const normal = {
    textAlign:'left',
    padding:'8px',
}

const dateStyle = {
    color: 'rgb(120, 120, 120)'
}


// WEBPACK FOOTER //
// ./src/components/Administration/SiteDetails/LogRow.js